import React from 'react';

import { formatAccountNumber } from '@eika-infrastruktur/format';
import { WarningMessage } from '@eika/attention-message';
import { Checkbox, CheckboxPanels } from '@eika/checkbox';
import { IconTypes } from '@eika/icon';

import useTranslation, { format } from '../../../hooks/useTranslation';
import { useAvtaleGiroMoveContext } from '../context/AvtaleGiroMoveContext';

type Props = {
    agreementsToShow?: string[];
};

const AgreementCheckboxes: React.FC<Props> = ({ agreementsToShow = [] }) => {
    const translated = useTranslation();

    const {
        selectedAgreements: [selectedAgreements, toggleSelectedAgreement],
        toggleSelectedAgreements: [toggleSelectedAgreements, toggleSelectAllAgreements],
        error: [errors],
        avtaleGiros: { data: avtaleGiros },
    } = useAvtaleGiroMoveContext();

    const targetAvtaleGiros = avtaleGiros.filter((avtaleGiro) =>
        agreementsToShow.length > 0 ? agreementsToShow.includes(avtaleGiro.id.value) : true,
    );

    return (
        <section className="move-avtalegiro-form__form-content">
            <h2>{translated.moveAvtaleGiro.avtaleGirosInOtherBanks}</h2>
            <div className="move-avtalegiro-form__choose-all-wrapper">
                <Checkbox
                    label={
                        toggleSelectedAgreements
                            ? translated.moveAvtaleGiro.removeChosen
                            : translated.moveAvtaleGiro.chooseAll
                    }
                    className="move-avtalegiro-form__checkbox"
                    id="toggle-selected-agreements"
                    checked={toggleSelectedAgreements}
                    onChange={(e) =>
                        toggleSelectAllAgreements(
                            e.target.checked ? targetAvtaleGiros : [],
                            agreementsToShow.length > 0,
                        )
                    }
                />
                <span className="move-avtalegiro-form__numbers">
                    {format(translated.moveAvtaleGiro.ofChosen, selectedAgreements.length, targetAvtaleGiros.length)}
                </span>
            </div>
            <CheckboxPanels
                label={<span className="screen-reader-text">{translated.moveAvtaleGiro.chooseAvtaleGiros}</span>}
                options={
                    targetAvtaleGiros.map((a) => ({
                        id: a.id.value,
                        label: a.creditorName ?? formatAccountNumber(a.creditorAccount),
                        value: a.id.value,
                        checked: selectedAgreements.includes(a.id.value),
                        onValueChange: () => toggleSelectedAgreement(a.id.value, agreementsToShow.length > 0),
                        'aria-invalid': !!errors.selectedAgreements,
                    })) ?? []
                }
            />
            {errors.selectedAgreements && (
                <WarningMessage
                    icon={IconTypes.UTROPSTEGN_24}
                    className="move-avtalegiro-form__error-message"
                    text={errors.selectedAgreements}
                />
            )}
        </section>
    );
};

export default AgreementCheckboxes;
